import type { ISchedule } from "@gettactic/api";
import { getScheduleRooms } from "@gettactic/helpers/src/schedules/getScheduleRooms";

/**
 * The rooms an edit has to send back to the API.
 *
 * The reserve form edits one room — the primary one — while a reservation can hold
 * several, and the update replaces the whole slot set: any room left out of the payload
 * is dropped from the reservation. So the rooms that were not being edited travel along
 * unchanged, and only the primary one is swapped for whatever the form now points at.
 */
export const getEditedReservationRoomIds = (
  original: ISchedule,
  selectedRoomId: string
): string[] => {
  const roomIds = getScheduleRooms(original).map((room) =>
    room.id === original.resource.id ? selectedRoomId : room.id
  );

  if (roomIds.length === 0) return [selectedRoomId];

  return Array.from(new Set(roomIds));
};
